exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--tags__21tAX{max-width:250px}.styles--tagsSmall__3BdU7{width:110px}.styles--tags__21tAX .styles--collapseLink__35OTr{font-size:13px}.styles--tags__21tAX .styles--collapseIcon__2J2ZT{display:inline-block;z-index:11}.styles--tags__21tAX .styles--tag__3G_m3{max-width:100px;font-size:13px;line-height:16px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.styles--tags__21tAX .styles--expanded__3O9_v{padding:5px;z-index:10}.styles--tags__21tAX .styles--expander__1Bbch{position:absolute;top:-1px;right:0;height:22px;padding:0 4px}.styles--tags__21tAX .styles--expanderWrap__1gdbo{position:relative}\n", ""]);

// exports
exports.locals = {
	"tags": "styles--tags__21tAX",
	"tagsSmall": "styles--tagsSmall__3BdU7",
	"collapseLink": "styles--collapseLink__35OTr",
	"collapseIcon": "styles--collapseIcon__2J2ZT",
	"tag": "styles--tag__3G_m3",
	"expanded": "styles--expanded__3O9_v",
	"expander": "styles--expander__1Bbch",
	"expanderWrap": "styles--expanderWrap__1gdbo"
};